// extracted by mini-css-extract-plugin
export default {"gallery":"c-o_ft","gallery__header":"c-o_fu","gallery__thumbs":"c-o_fv"};